import { render, staticRenderFns } from "./EditCreditCard.vue?vue&type=template&id=506bf87c&scoped=true&"
import script from "./EditCreditCard.vue?vue&type=script&lang=ts&"
export * from "./EditCreditCard.vue?vue&type=script&lang=ts&"
import style0 from "./EditCreditCard.vue?vue&type=style&index=0&id=506bf87c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506bf87c",
  null
  
)

export default component.exports